export const GET_EXCEPTION_DATA_TEMPLATE_REQUEST = 'GET_EXCEPTION_DATA_TEMPLATE_REQUEST'
export const GET_EXCEPTION_DATA_TEMPLATE_SUCCESS = 'GET_EXCEPTION_DATA_TEMPLATE_SUCCESS'
export const GET_EXCEPTION_DATA_TEMPLATE_FAILED = 'GET_EXCEPTION_DATA_TEMPLATE_FAILED'
